import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/app/App';
import '@/styles/index.css';
// Eager-load the theme store so its data-theme syncer runs before first paint.
import '@/state/themeStore';
// Register the sequence-clock flow's eventBus subscription at app start.
import '@/domain/sequenceFlow';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found. index.html must include <div id="root"></div>');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
